export const INDEX_START = 'INDEX_START';
export const INDEX_SUCCESS = 'INDEX_SUCCESS';
export const INDEX_FAILURE = 'INDEX_FAILURE';

export const INDEX_SAML_START = 'INDEX_SAML_START';
export const INDEX_SAML_SUCCESS = 'INDEX_SAML_SUCCESS';
export const INDEX_SAML_FAILURE = 'INDEX_SAML_FAILURE';

export const NEW_NODE_GROUP = 'NEW_NODE_GROUP';
export const CREATE_START = 'CREATE_START';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILURE = 'CREATE_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const DESTROY_START = 'DESTROY_START';
export const DESTROY_SUCCESS = 'DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'DESTROY_FAILURE';

export const NEW_NODES = 'NEW_NODES';
export const ADD_NODES_START = 'ADD_NODES_START';
export const ADD_NODES_SUCCESS = 'ADD_NODES_SUCCESS';
export const ADD_NODES_FAILURE = 'ADD_NODES_FAILURE';

export const REMOVE_NODES_START = 'REMOVE_NODES_START';
export const REMOVE_NODES_SUCCESS = 'REMOVE_NODES_SUCCESS';
export const REMOVE_NODES_FAILURE = 'REMOVE_NODES_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
